import { initPanels } from "./panels";
import { initPaddle } from "./paddle";

function isDesktopEnvironment(): boolean {
  return Boolean(
    (window as unknown as { shell?: unknown }).shell ||
    (typeof navigator !== "undefined" && /Electron/i.test(navigator.userAgent))
  );
}

function main(): void {
  if (isDesktopEnvironment()) {
    const search = window.location.search || "";
    const hash = window.location.hash || "";
    window.location.replace(`desktop.html${search}${hash}`);
    return;
  }

  const disposePanels = initPanels("web");
  initPaddle();

  window.addEventListener(
    "beforeunload",
    () => {
      disposePanels();
    },
    { once: true },
  );
}

main();

